var map = {
	"./book-1.png": 3592,
	"./book-2.png": 3593,
	"./book-3.png": 3594,
	"./book-4.png": 3595,
	"./book-5.png": 3596,
	"./book-6.png": 3597
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 371;



//////////////////
// WEBPACK FOOTER
// ./assets/images/reading/book-covers ^\.\/book\-.*\.png$
// module id = 371
// module chunks = 0